import React from "react";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PaymentInfo from "..";

const StripPayment = ({
  clientSecret,
  publish_key,
  handleSubmitCall,
  setHandleSubmitCall,
}) => {
  const stripePromise = loadStripe(publish_key);

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <>
      {clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <PaymentInfo
            handleSubmitCall={handleSubmitCall}
            setHandleSubmitCall={setHandleSubmitCall}
          />
        </Elements>
      )}
    </>
  );
};

export default StripPayment;
